import { render } from "./HeroiconsSolidQuestionMarkCircle.vue?vue&type=template&id=71f94526"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidQuestionMarkCircle.vue"]])

export default __exports__